import axios, { CancelTokenSource } from 'axios';
import clientInfo from 'common/lib/clientInfo';

import { GeneratorNameType } from 'common/components/CopyMagic/CopyMagic.types';

type CreateClaimsResponse = {
  url: string;
  token: string;
  modelName: string;
};

const authorizedClient = axios.create({
  baseURL: `${window.location.origin}/`,
  timeout: 15000, // 15 secs
  headers: {
    'Accept': 'application/json',
    'Content-Type': 'application/json',
    'Authorization': window.validationToken,
  },
});

const createClaims = async (generatorName: GeneratorNameType, requestSource: CancelTokenSource) => {
  const siteId = clientInfo.get('site_id');
  const url = siteId
    ? `/api/admin/sites/${siteId}/copy_magic/claims`
    : `/api/admin/copy_magic/claims`;

  const { data } = await authorizedClient.post<CreateClaimsResponse>(
    url,
    { generator_name: generatorName },
    { cancelToken: requestSource.token },
  );

  return data;
};

export default createClaims;
